import React, {ReactNode, CSSProperties} from 'react';
import './cards.scss';

interface ICardProps {
    style?: CSSProperties
    children?: ReactNode,
    [key: string]: any
}

interface ICardBodyProps {
    style?: CSSProperties
    children?: ReactNode
}

const Card = (props: ICardProps) => {
    const {style, children, ...restProps} = props;
    return (
        <div className='wb-card'data-testid='wb-card'    style={style} {...restProps}>
            {children}
        </div>
    )
}

const CardBody = (props: ICardBodyProps) => {
    return (
        <div className='wb-card-body'data-testid='wb-card-body'    style={props.style}>
            {props.children}
        </div>
    )
}

Card.Body = CardBody;

export default Card;
